import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'plurize' })
export class PlurizePipe implements PipeTransform {
  transform(
    value: string,
    count: number,
    suffix = 's',
    includeCount = true,
  ): string {
    if (includeCount) {
      return `${count} ${value}${count !== 1 ? suffix : ''}`;
    }
    return `${value}${count !== 1 ? suffix : ''}`;
  }
}
